import { render } from "./CrearSubmenu.vue?vue&type=template&id=88562784"
import script from "./CrearSubmenu.vue?vue&type=script&lang=js"
export * from "./CrearSubmenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__